<div class="container-fluid">

  <!-- Step 1: Template + Job Type + Location -->
  <nz-card nzTitle="Job Submission">
    <nz-row [nzGutter]="24">
      <nz-col [nzSpan]="12">
        <nz-form-item class="floating-label">
          <nz-form-label nzNoColon>Template Job</nz-form-label>
          <nz-select style="width: 100%" [(ngModel)]="templateJob" nzShowSearch nzAllowClear
            nzPlaceHolder="Select a job to use as template">
            @for (job of projectJobs(); track job.id) {
            <nz-option [nzValue]="job" [nzLabel]="job.name"></nz-option>
            }
          </nz-select>
        </nz-form-item>
      </nz-col>

      <nz-col [nzSpan]="12">
        <nz-form-item class="floating-label">
          <nz-form-label nzNoColon>Job Type</nz-form-label>
          <nz-select style="width: 100%" [ngModel]="selectedJobType()" (ngModelChange)="selectedJobType.set($event)"
            [nzDisabled]="true" nzAllowClear nzPlaceHolder="Select job type">
            @for (opt of jobTypeOptions; track opt.value) {
            <nz-option [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
            }
          </nz-select>
        </nz-form-item>
      </nz-col>

      <nz-col [nzSpan]="24">
        <nz-form-item class="floating-label">
          <nz-form-label nzNoColon nzRequired>Job Location</nz-form-label>
          <nz-form-control
            [nzValidateStatus]="(jobPathTouched() && !jobPath().trim()) || jobPathHasSpaces() ? 'error' : ''"
            [nzErrorTip]="jobPathHasSpaces() ? 'Job location cannot contain spaces' : 'Job location is required'">
            <input nz-input [ngModel]="jobPath()" (ngModelChange)="jobPath.set($event)"
              (blur)="jobPathTouched.set(true)" placeholder="/path/to/new/job" />
          </nz-form-control>
        </nz-form-item>
      </nz-col>
    </nz-row>
  </nz-card>

  <app-job-config
    [job]="templateJob()"
    [jobPath]="jobPath()"
    (configChange)="jobConfigValues.set($event)"
    (validityChange)="jobConfigValid.set($event)" />

  @if (templateJob() && selectedJobType()) {
    <app-file-assignment
      [loading]="jobTemplateResource.isLoading()"
      [fileSpecs]="currentFileSpecs()"
      [allFiles]="allFiles()"
      [runfiles]="runfiles()"
      [jobs]="projectJobs() ?? []"
      [templateJob]="templateJob()"
      [defaultBasePath]="templateFilesBasePath()"
      [xwiPrefix]="xwiPrefixForFiles()"
      (resolvedSelectionsChange)="resolvedSelections.set($event)"
      (resolvedRenamesChange)="resolvedRenames.set($event)">
    </app-file-assignment>
  }

  <app-file-editor style="display: block; margin-top: 15px"
    [job]="templateJob()"
    [runfile]="resolvedSelections()['runfile'] ?? null"
    [(editedRunfileContent)]="editedRunfileContent"
    [(editedEnvShContent)]="editedEnvShContent">
  </app-file-editor>

  <div class="submit-row">
    <button nz-button [disabled]="!canSubmit() || prepping()" [nzLoading]="prepping()" (click)="prep()" style="margin-right: 8px;">
      <span nz-icon nzType="tool" nzTheme="outline"></span>
      Prep Job
    </button>
    <!-- <button nz-button nzType="primary" [disabled]="!canSubmit() || submitting()" [nzLoading]="submitting()" (click)="submit()">
      <span nz-icon nzType="rocket" nzTheme="outline"></span>
      Submit Job
    </button> -->
  </div>

</div>

<ng-template #confirmSubmitTpl>
  <div class="confirm-details">
    <div class="confirm-summary">
      <div class="confirm-row">
        <span class="confirm-label">Project</span>
        <span class="confirm-value">{{ currentProject()?.name }}</span>
      </div>
      <div class="confirm-row">
        <span class="confirm-label">Template job</span>
        <span class="confirm-value">{{ templateJob()?.name }}</span>
      </div>
      <div class="confirm-row">
        <span class="confirm-label">Files selected</span>
        <span class="confirm-value">{{ (resolvedSelections() | keyvalue)?.length ?? 0 }} file(s)</span>
      </div>
      <div class="confirm-row confirm-row--stacked">
        <span class="confirm-label">New job path</span>
        <ng-container *ngTemplateOutlet="pathBox; context: { $implicit: formatJobPath(jobPath()) }"></ng-container>
      </div>
    </div>

    <label class="confirm-field">
      <span class="confirm-label">Job config name</span>
      <input
        nz-input
        class="confirm-input"
        [disabled]="prepping() || submitting()"
        [ngModel]="jobConfigValues()?.['job_name']"
        (ngModelChange)="updateJobConfigName($event)" />
    </label>

    @if (runfileLintIssues().length || envShLintIssues().length) {
      <div class="confirm-note confirm-note--warning">
        @if (runfileLintIssues().length) {
          {{ runfileLintIssues().length }} possible issue(s) in the runfile.
        }
        @if (envShLintIssues().length) {
          {{ envShLintIssues().length }} possible issue(s) in env.sh.
        }
        Check the File Editor tabs before continuing.
      </div>
    }
    @if (prepping() || submitting()) {
      <div class="confirm-note confirm-note--progress">
        <nz-spin nzSimple nzSize="small"></nz-spin>
        <span>{{ prepping() ? 'Preparing job' : 'Submitting job' }}… this can take a moment.</span>
      </div>
    }
    @if (actionError()) {
      <div class="confirm-note confirm-note--error">
        <strong>Request failed</strong>
        <span>{{ actionError() }}</span>
      </div>
    }
  </div>
</ng-template>

<ng-template #actionSuccessTpl let-modalRef="modalRef">
  @if (actionResult(); as result) {
    <div class="action-success">
      <div class="action-success__icon">
        <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12.5l4.5 4.5L19 7.5" />
        </svg>
      </div>
      <div class="action-success__eyebrow">{{ result.title }}</div>
      <div class="action-success__name">{{ result.jobName }}</div>
      <p class="action-success__message">{{ result.message }}</p>
      <div class="action-success__path">
        <ng-container *ngTemplateOutlet="pathBox; context: { $implicit: result.path }"></ng-container>
      </div>
      <button nz-button nzType="primary" class="action-success__done" (click)="modalRef?.destroy()">Done</button>
    </div>
  }
</ng-template>

<ng-template #pathBox let-path>
  <div class="path-box">
    <code class="confirm-path">{{ path }}</code>
    <button type="button" class="path-box__copy" [class.path-box__copy--done]="pathCopied()"
      nz-tooltip [nzTooltipTitle]="pathCopied() ? 'Copied' : 'Copy path'" (click)="copyPath(path)">
      <span nz-icon [nzType]="pathCopied() ? 'check' : 'copy'" nzTheme="outline"></span>
    </button>
  </div>
</ng-template>
